"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigateToActivity = void 0;
var react_1 = require("react");
var constants_1 = __importDefault(require("../../../../config/constants"));
var framework_1 = require("../../../../widgets/framework");
var useNavigateToActivity = function () {
    var navigateToActivity = (0, react_1.useCallback)(function (activity) {
        var appNavigate;
        if (activity.key === constants_1.default.INVITE_FRIENDS_ACTIVITY_KEY) {
            appNavigate = {
                action: 'INVITE_FRIENDS',
                data: activity
            };
        }
        else {
            appNavigate = {
                action: 'ACTIVITY_DETAILS',
                data: activity
            };
        }
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    return {
        navigateToActivity: navigateToActivity
    };
};
exports.useNavigateToActivity = useNavigateToActivity;
//# sourceMappingURL=useNavigateToActivity.js.map